import CommonAPI from './CommonAPI.js';
import Auth from './Auth.js'

import Logger from './Logger.js'
import CommonUtil from './CommonUtil.js'


export default {
  test() {
    Logger.debug(Auth.getToken())
  },

  // Authentication methods moved to AuthService
  // Use AuthService.requestCode() and AuthService.confirmCode() instead

  
  getNomineeIntro(topicHash, func_ok, func_error) {
    if (!func_error) func_error = this._common_error

    return CommonAPI.instance().get(
      `/api/nominee/public/topics/${topicHash}/status`,
      {})
      .then(res => func_ok(res.data))
      .catch((err) => func_error(err))
  },

  getTopicStatus(topicHash, func_ok, func_error) {
    if (!func_error) func_error = this._common_error

    return CommonAPI.instance().get(
      `/api/nominee/public/topics/${topicHash}/status`,
      {})
      .then(res => func_ok(res.data))
      .catch((err) => func_error(err))
  },

  getCandidateInfo(registerHash, func_ok, func_error) {
    if (!func_error) func_error = this._common_error

    return CommonAPI.instance().get(
      `/api/nominee/public/candidates/${registerHash}`,
      {})
      .then(res => func_ok(res.data))
      .catch((err) => func_error(err))
  },

  /**
   * 입후보 등록 폼 정보 조회 (선거인 본인 정보 + 주제 정보)
   * @param {string} topicHash - 선거 주제 해시
   */
  getNomineeForm(topicHash, func_ok, func_error) {
    if (!func_error) func_error = this._common_error

    // 먼저 주제 정보를 가져옴
    CommonAPI.instance().get(
      `/api/nominee/public/topics/${topicHash}/status`,
      {})
      .then(topicRes => {
        const topicData = topicRes.data.data
        
        // 그 다음 인증된 선거인의 본인 정보를 가져옴
        CommonAPI.instance().get(
          `/api/nominee/elector/my-info`,
          {
            headers: Auth.headers()
          })
          .then(electorRes => {
            const electorData = electorRes.data.data
            
            // 두 정보를 합쳐서 폼 데이터 구성
            const formData = {
              code: 200,
              data: {
                clazz: topicData.topic.clazz,
                partnerCount: topicData.topic.partnerCount,
                name: electorData.name,
                team: electorData.team,
                district: electorData.electionWard,
                employeeNumber: electorData.employeeNumber,
                phone: electorData.phone
              }
            }
            
            func_ok(formData)
          })
          .catch((err) => func_error(err))
      })
      .catch((err) => func_error(err))
  },

  /**
   * 입후보 등록
   * @param {string} topicHash - 선거 주제 해시
   * @param {string} rrn - 주민등록번호 (형식: 123456-1******)
   * @param {string} opinion - 입후보 소견
   */
  registerNominee(topicHash, rrn, opinion, func_ok, func_error) {
    if (!func_error) func_error = this._common_error

    return CommonAPI.instance().post(
      `/api/nominee/elector/topics/${topicHash}/register`,
      {
        rrn: rrn,
        candidacyOpinion: opinion
      },
      {
        headers: Auth.headers()
      })
      .then(res => func_ok(res.data))
      .catch((err) => func_error(err))
  },

  /**
   * 입후보 완료 정보 조회 (선거인 본인의 후보 등록 정보 + 주제 정보)
   * @param {string} topicHash - 선거 주제 해시
   */
  getMyInfo(topicHash, func_ok, func_error) {
    if (!func_error) func_error = this._common_error

    // 먼저 주제 정보를 가져옴
    CommonAPI.instance().get(
      `/api/nominee/public/topics/${topicHash}/status`,
      {})
      .then(topicRes => {
        const topicData = topicRes.data.data
        
        // 본인의 후보 등록 정보 조회
        CommonAPI.instance().get(
          `/api/nominee/elector/my-candidate`,
          {
            headers: Auth.headers()
          })
          .then(candidateRes => {
            const candidateData = candidateRes.data.data
            
            const myInfo = {
              code: 200,
              data: {
                topicTitle: topicData.topic.title,
                registerHash: candidateData.registerHash,
                employeeNumber: candidateData.employeeNumber,
                name: candidateData.name,
                team: candidateData.team,
                electionWard: candidateData.electionWard,
                status: candidateData.status,
                recommendationCount: candidateData.recommendationCount,
                requiredRecommendations: candidateData.requiredRecommendations
              }
            }
            
            func_ok(myInfo)
          })
          .catch((err) => func_error(err))
      })
      .catch((err) => func_error(err))
  },

  submitCandidate(registerHash, func_ok, func_error) {
    if (!func_error) func_error = this._common_error

    return CommonAPI.instance().post(
      `/api/nominee/elector/candidates/${registerHash}/submit`,
      {},
      {
        headers: Auth.headers()
      })
      .then(res => func_ok(res.data))
      .catch((err) => func_error(err))
  },

  cancelCandidate(registerHash, func_ok, func_error) {
    if (!func_error) func_error = this._common_error

    return CommonAPI.instance().post(
      `/api/nominee/elector/candidates/${registerHash}/cancel`,
      {},
      {
        headers: Auth.headers()
      })
      .then(res => func_ok(res.data))
      .catch((err) => func_error(err))
  },

  _common_error(err) {
    Logger.debug("error" + err)
    alert(CommonUtil.extractErrorMessage(err))
  },
  
}